import { InjectionToken } from '@angular/core';
import { IIngeniqueApiConfig } from './interfaces/ingenique-api.interface';

export const INGENIQUE_API_CONFIG = new InjectionToken<IIngeniqueApiConfig>('ingeniqueApiConfig');
